import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../../../core/services/language.service';
import { CommonModule } from '@angular/common';
import { InsertLicenseResponse, MyVehicleResponse, StatusAPIResponseMain, UpdateLicensePayload } from '../../../../../core/models/information.model';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { Subscription } from 'rxjs';
import { VehicleDefaultPayload } from '../../../../../core/models/user.model';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { PssWarnComponent } from "../../../../../tools/template/pss/pss-warn/pss-warn.component";
import { ApiVehicleService } from '../../../../../core/services/api/Vehicle/api-vehicle';
import { ApiLicenseService } from '../../../../../core/services/api/Vehicle/api-license';
import { ApiVehicleShareService } from '../../../../../core/services/api/Vehicle/api-vehicle-share';
import { ModalVehicleShareComponent } from '../../../modals/member-information-category/vehicles/modal-vehicle-share/modal-vehicle-share.component';
import { ShareVehicleInviteResponse, ShareVehicleMemberResponse, vehicleShareResponse } from '../../../../../core/models/member.model';

export interface DisplayVehicleItem {
  id: number; // vehicleId
  name: string;
  province: string;
  vehicle_type_name: string;
  is_default: boolean;
  isShared: boolean;
  groupId?: number;
  memberCount?: number;
}

@Component({
  selector: 'app-vehicles-option-2',
  imports: [CommonModule, PssLoadingComponent, PssWarnComponent, ModalVehicleShareComponent],
  templateUrl: './vehicles-option-2.component.html',
  styleUrl: './vehicles-option-2.component.css'
})
export class VehiclesOption2Component {
  currentLang: 'TH' | 'EN' = 'TH'
  sub!: Subscription;

  interactionStatus: boolean = false;
  stateProgress: number = 0;
  selectedPlan: number = 0;

  uid: string = '';
  token: string = '';
  isLoading: boolean = false;
  vehicleDetails: MyVehicleResponse[] = [];
  plans: MyVehicleResponse[] = [];
  showModal_Delconfirm: boolean = false;
  showModal_Editconfirm: boolean = false;
  license: string = '';
  vehicleId: number = 0;

  isOpen: boolean = false;
  displayName: string = '';
  todayDate: string = '';

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''

  // Share Vehicle variables
  displayVehicles: DisplayVehicleItem[] = [];
  sharedVehicles: vehicleShareResponse[] = [];

  showModal_Share: boolean = false;
  showModal_ManageShare: boolean = false;
  selectedGroup: DisplayVehicleItem | null = null;
  members: ShareVehicleMemberResponse[] = [];
  pendingInvites: ShareVehicleInviteResponse[] = [];
  pendingInboxCount: number = 0;

  showConfirmRevoke: boolean = false;
  revokeTarget: ShareVehicleMemberResponse | null = null;
  showConfirmDissolve: boolean = false;

  constructor(
    private router: Router,
    private apiVehicleService: ApiVehicleService,
    private apiLicenseService: ApiLicenseService,
    private apiVehicleShareService: ApiVehicleShareService,
    private cookie: CookieService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private languageService: LanguageService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.token = '';
    this.uid =
      this.cookie.get('line_uid') || localStorage.getItem('line_uid') || '';
    this.displayName = localStorage.getItem('line_name') || this.cookie.get('line_name') || 'User';

    const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
    this.todayDate = new Date().toLocaleDateString(this.currentLang === 'TH' ? 'th-TH' : 'en-US', options);

    setTimeout(() => {
      this.getMyVehicle(this.uid);
      this.loadInboxCount();
    }, 100);
  }

  loadInboxCount() {
    this.apiVehicleShareService.getInvitesInbox(this.uid, 'pending').subscribe({
      next: (res) => {
        this.pendingInboxCount = (res || []).length;
      },
      error: () => {
        this.pendingInboxCount = 0;
      }
    });
  }
  /* -------------------------------------------- Function ----------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess(text, detail)
  }
  toggleInteractionStatus(status: boolean) {
    this.interactionStatus = status;
  }

  /* ---- Function ---- */
  goBack() {
    this.router.navigate(['/home']);
  }
  goToInbox() {
    this.router.navigate(['/vehicle-share-inbox']);
  }
  getMyVehicle(uid: string): void {
    this.isLoading = true;
    this.apiVehicleService.getMyVehicle(this.token, this.uid).subscribe({
      next: (response: MyVehicleResponse[]) => {
        this.plans = response || [];
        const defaultPlan = response.find((plan) => plan.is_default);
        if (defaultPlan) {
          this.selectedPlan = defaultPlan.id;
        }
        this.loadSharedVehicles();
      },
      error: (err) => {
        console.error('❌ API error:', err);
        this.plans = [];
        this.loadSharedVehicles();
      },
    });
  }

  loadSharedVehicles() {
    this.apiVehicleShareService.getVehicleShare(this.uid).subscribe({
      next: (res) => {
        this.sharedVehicles = res || [];
        this.mergeVehicles();
        this.isLoading = false;
      },
      error: () => {
        this.sharedVehicles = [];
        this.mergeVehicles();
        this.isLoading = false;
      }
    });
  }

  mergeVehicles() {
    const list: DisplayVehicleItem[] = [];

    this.plans.forEach(v => {
      const shareGroup = this.sharedVehicles.find(s => s.id === v.share_group_id || s.vehicleId === v.id);
      list.push({
        id: v.id,
        name: v.name,
        province: v.province,
        vehicle_type_name: v.vehicle_type_name,
        is_default: v.is_default,
        isShared: !v.is_owner,
        groupId: v.share_group_id || shareGroup?.id,
        memberCount: shareGroup?.memberCount || 0
      });
    });

    this.displayVehicles = list;
  }

  goToAddVehicle() {
    this.router.navigate(['/vehicle-setting'], {
      state: { carId: 0, new: true },
    });
  }

  editPlan(payload: any) {
    this.license = '';
    if (payload) {
      if (payload.isShared) {
        this.showWarning(this.currentLang === 'TH' ? 'ไม่สามารถแก้ไขรถยนต์แชร์ได้' : 'Cannot edit shared vehicle');
        return;
      }
      this.selectedPlan = payload.id;
      this.license = payload.name;
      console.log("Paylopad Edit : ", this.selectedPlan, this.license);
      this.showModal_Editconfirm = true;
    } else {
      this.showError('แก้ไขค่าเริ่มต้นไม่สำเร็จ !');
    }
  }

  deletePlan(payload: any) {
    this.license = '';
    this.vehicleId = 0;
    console.log(payload);
    if (payload) {
      this.license = payload.name;
      this.selectedPlan = payload.id;
      if (payload.isShared) {
        this.leaveGroup(payload);
      } else {
        this.showModal_Delconfirm = true;
      }
    }
  }

  deleteCar() {
    if (this.selectedPlan != 0) {
      this.deleteVehicle();
    } else {
      this.showError('Error  !');
    }
  }

  goHome() {
    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 0);
  }

  EditCar() {
    if (this.selectedPlan != 0) {
      this.showModal_Editconfirm = false;
      this.router.navigate(['/vehicle-setting'], {
        state: { carId: this.selectedPlan, new: false, stateProgress: 1 },
      });
    } else {
      this.showError('Error  !');
    }
  }

  deleteVehicle() {
    this.showModal_Delconfirm = false;
    if (this.selectedPlan) {
      this.isLoading = true;
      const payload: UpdateLicensePayload = {
        uid: this.uid,
        oldLicense: this.license,
        license: this.license,
        id: this.selectedPlan,
        oldVehicleType: '',
        vehicleType: '',
        oldBrand: '',
        brand: '',
        oldModel: '',
        model: '',
        oldEngineType: '',
        engineType: '',
        oldColor: '',
        color: '',
        oldProvince: '',
        province: '',
        statusVehicleId: 3,
      };

      if (payload) {
        console.log("Vehicle Delete : ", JSON.stringify(payload, null, 2));
        this.apiVehicleService.updateCityVehicle(payload, this.token).subscribe({
          next: (res: StatusAPIResponseMain) => {
            console.log("Response Vehicle delete : ", res);
            this.isLoading = false;
            if (res) {
              if (res.code == '000') {
                this.showSuccess(
                  this.currentLang === 'TH'
                    ? 'ลบสำเร็จ'
                    : 'Delete successfully.'
                  , this.currentLang === 'TH'
                    ? 'ทำการลบเรียบร้อย'
                    : 'Delete process successfully.'
                );
                setTimeout(() => {
                  this.getMyVehicle(this.uid);
                }, 100);
              } else {
                this.showError(
                  this.currentLang === 'TH'
                    ? 'ทำการลบไม่สำเร็จ'
                    : 'Delete not successful.'
                );
              }
            } else {
              this.showError('can not delete this Vehicle');
            }
          },
          error: (err) => {
            console.error('❌  not succeed:', err);
            this.isLoading = false;
            this.showError('can not delete this Vehicle');
          },
        });
      } else {
        console.log('No payload');
      }
    } else {
      console.log('No select Plan');
    }
  }

  selectDefaultVehicle(plan: DisplayVehicleItem) {
    this.selectedPlan = plan.id;
    this.updateDefault();
  }

  /* ================= Group Share Functions ================= */

  openManageGroup(vehicle: DisplayVehicleItem) {
    if (!vehicle.isShared) {
      this.selectedGroup = vehicle;
      this.showModal_ManageShare = true;
      this.loadMembers(vehicle.groupId || 0);
      this.loadPendingForVehicle(vehicle.id);
    } else {
      this.selectedGroup = vehicle;
      this.leaveGroup(vehicle);
    }
  }

  closeManageGroup() {
    this.showModal_ManageShare = false;
    this.selectedGroup = null;
    this.members = [];
    this.pendingInvites = [];
  }

  loadMembers(groupId: number) {
    if (!groupId) return;
    this.apiVehicleShareService.getVehicleShareDetails(this.uid, groupId).subscribe({
      next: (res) => {
        this.members = (res || []).filter((m) => !m.disable);
      },
      error: () => {
        this.members = [];
      },
    });
  }

  loadPendingForVehicle(vehicleId: number) {
    this.apiVehicleShareService.getInvitesSent(this.uid, 'pending').subscribe({
      next: (res) => {
        this.pendingInvites = (res || []).filter((i) => i.vehicleId === vehicleId);
      },
      error: () => {
        this.pendingInvites = [];
      },
    });
  }

  askRevoke(member: ShareVehicleMemberResponse) {
    this.revokeTarget = member;
    this.showConfirmRevoke = true;
  }

  confirmRevoke() {
    if (!this.selectedGroup || !this.revokeTarget) return;
    const groupId = this.selectedGroup.groupId || 0;
    const cpUserId = this.revokeTarget.cpUserId;
    this.showConfirmRevoke = false;
    this.apiVehicleShareService
      .revokeMember({ uid: this.uid, groupId, cpUserId })
      .subscribe({
        next: (res) => {
          if (res?.code === '000' || res?.success) {
            this.showSuccess(res.message || (this.currentLang === 'TH' ? 'ถอนสิทธิ์สำเร็จ' : 'Revoked'));
            this.loadMembers(groupId);
            this.getMyVehicle(this.uid);
          } else {
            this.showError(this.currentLang === 'TH' ? (res?.message || 'ไม่สำเร็จ') : (res?.message_en || 'Failed'));
          }
        },
        error: () => this.showError(this.currentLang === 'TH' ? 'ไม่สำเร็จ' : 'Failed'),
      });
  }

  cancelPending(invite: ShareVehicleInviteResponse) {
    this.apiVehicleShareService
      .cancelInvite({ uid: this.uid, inviteId: invite.id })
      .subscribe({
        next: (res) => {
          if (res?.code === '000' || res?.success) {
            this.showSuccess(res.message || (this.currentLang === 'TH' ? 'ยกเลิกคำเชิญแล้ว' : 'Cancelled'));
            if (this.selectedGroup) {
              this.loadPendingForVehicle(this.selectedGroup.id);
            }
          } else {
            this.showError(this.currentLang === 'TH' ? (res?.message || 'ไม่สำเร็จ') : (res?.message_en || 'Failed'));
          }
        },
        error: () => this.showError(this.currentLang === 'TH' ? 'ไม่สำเร็จ' : 'Failed'),
      });
  }

  askDissolve() {
    this.showConfirmDissolve = true;
  }

  confirmDissolve() {
    if (!this.selectedGroup) return;
    const groupId = this.selectedGroup.groupId || 0;
    this.showConfirmDissolve = false;
    this.apiVehicleShareService.dissolveGroup({ uid: this.uid, groupId }).subscribe({
      next: (res) => {
        if (res?.code === '000' || res?.success) {
          this.showSuccess(res.message || (this.currentLang === 'TH' ? 'ยุบกลุ่มสำเร็จ' : 'Dissolved'));
          this.closeManageGroup();
          this.getMyVehicle(this.uid);
        } else {
          this.showError(this.currentLang === 'TH' ? (res?.message || 'ยุบไม่ได้') : (res?.message_en || 'Cannot dissolve'));
        }
      },
      error: () => this.showError(this.currentLang === 'TH' ? 'ยุบไม่ได้' : 'Cannot dissolve'),
    });
  }

  leaveGroup(vehicle: DisplayVehicleItem) {
    const groupId = vehicle.groupId || 0;
    const thConfirm = `ต้องการออกจากแชร์ของทะเบียน ${vehicle.name} ใช่หรือไม่?`;
    const enConfirm = `Are you sure you want to leave sharing for vehicle ${vehicle.name}?`;

    if (confirm(this.currentLang === 'TH' ? thConfirm : enConfirm)) {
      this.apiVehicleShareService.leaveShare({ uid: this.uid, groupId }).subscribe({
        next: (res) => {
          if (res?.code === '000' || res?.success) {
            this.showSuccess(res.message || (this.currentLang === 'TH' ? 'ออกจากแชร์แล้ว' : 'Left group'));
            this.getMyVehicle(this.uid);
          } else {
            this.showError(this.currentLang === 'TH' ? (res?.message || 'ไม่สำเร็จ') : (res?.message_en || 'Failed'));
          }
        },
        error: () => this.showError(this.currentLang === 'TH' ? 'ไม่สำเร็จ' : 'Failed'),
      });
    }
  }

  updateDefault() {
    if (this.selectedPlan) {
      this.isLoading = true;
      // console.log(this.selectedPlan);
      const payload: VehicleDefaultPayload = {
        uid: this.uid,
        vehicle_id: this.selectedPlan,
      };

      // console.log(JSON.stringify(payload).toString());
      if (payload) {
        this.apiLicenseService.editLicenseDefault(payload, this.token).subscribe({
          next: (res: InsertLicenseResponse) => {
            // console.log('📦 Response:', res);
            this.isLoading = false;
            if (res.code == '000') {
              this.showSuccess(
                this.currentLang === 'TH'
                  ? 'บันทึกสำเร็จ'
                  : 'Saved successfully.'
              );
            } else {
              this.showError(
                this.currentLang === 'TH'
                  ? 'บันทึกไม่สำเร็จ'
                  : 'Save not successful.'
              );
            }
          },
          error: (err) => {
            console.error('❌  ไม่สำเร็จ:', err);
            this.isLoading = false;
            this.showError(
              this.currentLang === 'TH'
                ? 'บันทึกไม่สำเร็จ'
                : 'Save not successful.'
            );
          },
        });
      }
    } else {
      this.isLoading = false;
      console.log('No selected');
    }
  }
}
